<!-- svelte-ignore a11y-label-has-associated-control -->
{#if charity}

  {#if !charity.isOwnershipVerified && user}
    <article class="message is-warning">
      <div class="message-body">
        {#if charity.type === 'EnglandAndWalesRegistered'}
          <p class="block">
            The email address used to sign up does not match the details
            registered with the Charity Commission.
          </p>
          <p class="block">
            - User email address '{userId}' does <b>not</b> exactly match registered
            address '{charity.contact.email}'
          </p>
          <p class="block">
            - User email address '{userId}' is <b>not</b> in the same domain as the
            charity website '{charity.website}'
          </p>

          <p class="block">
            <b
              >Please verify that the email address used to sign up is valid for
              this organisation.</b
            >
          </p>
        {:else if charity.type === 'ScotlandRegistered'}
          <p class="block">
            This charity claims to be registered with the Scottish Charity Commission.
          </p>
          <p class="block">
            <b>Please verify that:</b>
          </p>
          <p class="block">
            - The organisation is a Scottish registered charity. <a href="https://www.oscr.org.uk/about-charities/search-the-register/charity-details?number={charity.info.charityNumber}" target="_blank">Search the registry</a>.
          </p>
          <p class="block">
            - The email address used to sign up is valid for this organisation.
          </p>
        {:else if charity.type === 'NorthernIrelandRegistered'}
          <p class="block">
            This charity claims to be registered with the Northern Irish Charity Commission.
          </p>
          <p class="block">
            <b>Please verify that:</b>
          </p>
          <p class="block">
            - The organisation is a Northern Ireland registered charity. <a href="https://www.charitycommissionni.org.uk/charity-search?searchText={charity.info.charityNumber}&pageNumber=1" target="_blank">Search the registry</a>.
          </p>
          <p class="block">
            - The email address used to sign up is valid for this organisation.
          </p>
        {:else if charity.type === 'CIC'}
          <p class="block">
            This charity claims to be a Community Interest Company (CIC).
          </p>
          <p class="block">
            <b>Please verify that:</b>
          </p>
          <p class="block">
            - The organisation is a CIC. <a href="https://find-and-update.company-information.service.gov.uk/search?q={charity.info.companyNumber}" target="_blank">Search Companies House</a>.
          </p>
          <p class="block">
            - The email address used to sign up is valid for this organisation.
          </p>
        {:else if charity.type === 'CBS'}
          <p class="block">
            This charity claims to be a Community Benefit Society (CBS).
          </p>
          <p class="block">
            <b>Please verify that:</b>
          </p>
          <p class="block">
            - The organisation is a CBS. <a href="https://mutuals.fca.org.uk/Search/Search?SearchTerm={charity.info.registrationNumber}" target="_blank">Search the FCA</a>.
          </p>
          <p class="block">
            - The email address used to sign up is valid for this organisation.
          </p>
        {:else if charity.type === 'HMRCCharity'}
          <p class="block">
            This charity claims to have HMRC charity tax status.
          </p>
          <p class="block">
            <b>Please verify that:</b>
          </p>
          <p class="block">
            - The organisation has HMRC charity status. Request a copy of their HMRC charity registration.
          </p>
          <p class="block">
            - The email address used to sign up is valid for this organisation.
          </p>
        {:else}
          <p class="block">
            This charity does not claim to be a registered registry, CIC, CBS or HMRC Charity 
          </p>
          <p class="block">
            <b>Please contact them to discuss elibility</b>
          </p>
        {/if}
      </div>
    </article>
  {/if}

  {#if showToast}
    <div class="notification is-success">
      <button class="delete" on:click={() => (showToast = false)} />
      Contact and charity updated
    </div>
  {/if}

  <hr />
  <h2 class="is-size-4">Contact</h2>

  {#if user}

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Email</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={userId} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">First name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={user.firstName} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Last name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={user.lastName} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Phone</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={user.phone} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <a href="{$url('/admin/user/' + userId)}">View details</a>
        </div>
      </div>
    </div>
  </div>

  {:else}

  <div>No user account associated with this charity.</div>

  {/if}

  <hr />
  <h2 class="is-size-4 mb-3">Charity</h2>

  {#if charity.type === 'EnglandAndWalesRegistered'}
    <EnglandWalesCharityFull {charity} />
  {:else if charity.type === 'ScotlandRegistered'}
    <ScotlandCharityFull {charity} />
  {:else if charity.type === 'NorthernIrelandRegistered'}
    <NorthernIrelandCharityFull {charity} />
  {:else if charity.type === 'CIC'}
    <CICFull {charity} />
  {:else if charity.type === 'CBS'}
    <CBSFull {charity} />
  {:else if charity.type === 'HMRCCharity'}
    <HMRCCharityFull {charity} />
  {:else}
    <UnregisteredCharityFull {charity} />
  {/if}

  {#if errorMessage}
    <div class="block">
      <div class="notification is-danger is-light">
        {errorMessage}
      </div>
    </div>
  {/if}
{/if}

<script lang="ts">
  export let id: string;

  import _ from 'lodash';
  import { goto, url, params } from '@sveltech/routify';
  import { appState } from '../../../../lib/appState';
  import { uiState } from '../../../../lib/uiState';
  import { logging } from '../../../../lib/logging';
  import EnglandWalesCharityFull from '../../../_components/org_profiles/EnglandWalesCharityFull.svelte';
  import ScotlandCharityFull from '../../../_components/org_profiles/ScotlandCharityFull.svelte';
  import NorthernIrelandCharityFull from '../../../_components/org_profiles/NorthernIrelandCharityFull.svelte';
  import CICFull from '../../../_components/org_profiles/CICFull.svelte';
  import CBSFull from '../../../_components/org_profiles/CBSFull.svelte';
  import HMRCCharityFull from '../../../_components/org_profiles/HMRCCharityFull.svelte';
  import UnregisteredCharityFull from '../../../_components/org_profiles/UnregisteredCharityFull.svelte';

  id = $params["id"];

  let charity: Charity_v2;
  let user: User_v1;
  let userId: string;

  let showToast = false;
  let errorMessage: string;

  let firebase = window.firebase;

  get();

  async function get() {
    firebase
      .firestore()
      .collection('charities_v2')
      .doc(id)
      .onSnapshot((doc) => {
        charity = doc.data() as Charity_v2;
      });

    firebase
      .firestore()
      .collection('users_v1')
      .where('charity', '==', id)
      .get()
      .then((snap) => {
        const doc = _.find(snap.docs, (doc) => !doc.data().isAdmin);
        if (doc) {
          userId = doc.id;
          user = doc.data() as User_v1;
        }
      });
  }

  let clipboardAvailable = navigator.clipboard != undefined;
  let copied = false;

  async function copyToClipboard(value: string) {
    try {
      await navigator.clipboard.writeText(value);
      copied = true;
    } catch (error: any) {
      logging.report(error.toString());
      console.error('copy failed', error);
    }
  }
</script>
